import { useState } from "react";
export const instructorDetails = {
	name: "Pradnya Kapuskar",
	src: "/baad.jpeg",
	tagline: "Product Designer, Creative Strategist",
};

export function CourseDesc() {
	const [showFullDescription, setShowFullDescription] = useState(false);

	const toggleDescription = () => {
		setShowFullDescription((prev) => !prev);
	};

	return (
		<div className="description-section">
			<h2>Description</h2>

			<div className="description-content">
				<p>
					Are you ready to build the next generation of digital products? This
					intensive bootcamp is designed to take you from a complete beginner to
					a confident designer capable of building professional-grade web and
					mobile apps.
				</p>

				<p>
					Through hands-on projects, you will master the science of User
					Experience (UX) and the art of User Interface (UI) design. You won't
					just learn how to make things look pretty; you’ll learn how to solve
					real problems using Figma, the industry’s most powerful design tool.
				</p>

				<p>
					By the end of this course, you will have a complete, end-to-end UX
					project and an interactive prototype to showcase in your portfolio.
				</p>

				{showFullDescription && (
					<>
						<h3>What is UI/UX Design?</h3>

						<p>
							Think of your favorite app. UX (User Experience) is how it
							works—the logic, the ease of use, and how it solves your problems
							without making you frustrated. UI (User Interface) is how it
							looks—the beautiful colors, the sleek buttons, and the polished
							fonts that make you enjoy using it.
						</p>

						<p>
							Together, they are the "secret sauce" that makes apps like
							Instagram, Uber, or Spotify successful. Without good UI/UX, a
							product fails.
						</p>

						<h3>Why Choose UI/UX as a Career?</h3>

						<p>
							In 2026, every company—from global tech giants to local
							startups—is a "digital company." They are all fighting for user
							attention, and they are desperate for designers who can make their
							products stand out.
						</p>

						<p>
							High Demand, High Salary: UI/UX design is consistently ranked as
							one of the top 10 most in-demand skills in tech. Because you
							directly impact a company's revenue (better design = more
							customers), businesses are willing to pay a premium for your
							expertise.
						</p>

						<p>
							Zero Coding Required: You get to work in the "High Tech" world and
							enjoy the perks (remote work, creative freedom, high pay) without
							ever having to write a single line of code.
						</p>

						<p>
							Future-Proof Your Career: As AI changes the world, the need for
							human empathy and creative problem-solving—the core of UX—is more
							important than ever. You aren't just pushing pixels; you are
							designing the future of how humans interact with technology.
						</p>

						<p>
							A Portfolio That Speaks for You: Unlike other fields where you
							need a 4-year degree, in UI/UX, your portfolio is your degree. By
							the end of this 6-week course, you will have a professional,
							end-to-end project that proves to recruiters you can do the job on
							Day 1.
						</p>

						<p>
							Stop being just a user of technology and start being the one who
							builds it. Join us and turn your creativity into a career.
						</p>
					</>
				)}
			</div>

			<button className="show-more-btn" onClick={toggleDescription}>
				{showFullDescription ? "Show less" : "Show more"}
			</button>
		</div>
	);
}

export function CourseFor() {
	return (
		<div className="for-course-section">
			<h2>Who this course is for:</h2>
			<ul>
				<li>
					Anyone who wants to start using Figma in their career & get paid for
					their user experience design skills.
				</li>
				<li>
					This course is for beginners, newbies & amateurs in the field of UX
					design.
				</li>
				<li>Aimed at people new to the world of design & user experience.</li>
				<li>For anyone that needs to add ‘UX Design’ to their portfolio.</li>
				<li>Anyone who wants to learn the essentials of UI & UX Design.</li>
			</ul>
		</div>
	);
}

export const courseCiricullum = [
	{
		heading: "Introduction",
		contents: [
			"What is UI/UX, really?",
			"Starting with the 'Why': Analyzing a UX brief and identifying user problems",
			"Understanding the Figma Interface",
			"Looking Ahead: The Final Project",
		],
	},
	{
		heading: "Section 1: UX Strategy & Research",
		contents: ["The UX Brief", "User Personas", "User Journey Mapping"],
	},
	{
		heading: "Section 2: Architecture & Wireframing",
		contents: ["User Flows", "Low-Fidelity Wireframing", "Boolean Operations"],
	},
	{
		heading: "Section 3: Visual Design & UI Essentials",
		contents: [
			"Color Theory & Accessibility",
			"Web vs. Mobile Typography",
			"Imagery & Masking",
		],
	},
	{
		heading: "Section 4: Dynamic UI Components",
		contents: [
			"Atomic Design Principles",
			"Building a Design System",
			"Responsive Design Logic",
			"Main Components, Auto Layout, and Constraints",
		],
	},
	{
		heading: "Section 5: Advanced Component Architecture",
		contents: [
			"Multi-Dimensional Variants",
			"Component Properties",
			"State Management",
			"Variants, Boolean Properties, and Instance Swap",
		],
	},
	{
		heading: "Section 6: Interactive Prototyping & Motion",
		contents: [
			"Page Transitions",
			"Micro-interactions",
			"Advanced Animation",
			"Prototype Mode, Smart Animate, and Overlays",
		],
	},
	{
		heading: "Section 7: Workflow & Community Tools",
		contents: [
			"Free UI Kits",
			"Efficiency Plugins",
			"External Assets Integration",
		],
	},
	{
		heading: "Section 8: Asset Export & Client Handoff",
		contents: [
			"Simple Style Guides",
			"Production-Ready Assets",
			"Developer Collaboration",
		],
	},
];

export function CourseReq() {
	return (
		<div className="requirements-section">
			<h2>Requirements</h2>
			<ul>
				<li>A free plan available on the Figma website.</li>
				<li>No previous UX Design/UI Design experience is needed.</li>
				<li>No previous Figma skills are needed.</li>
				<li>No previous design skills or experience required.</li>
				<li>Any computer and OS will work — Windows, macOS or Linux.</li>
			</ul>
		</div>
	);
}

export function CourseWhatLearn() {
	return (
		<div className="what-you-learn">
			<h2>What you'll learn</h2>
			<div className="learn-grid">
				<div className="learn-item">
					How to begin working as a UX Designer using Figma
				</div>

				<div className="learn-item">
					How to use Figma for Essential UX Design & UI Design
				</div>

				<div className="learn-item">
					How to make fully interactive prototypes
				</div>

				<div className="learn-item">How to work with a UX personas</div>

				<div className="learn-item">
					Build a UX project from beginning to end
				</div>

				<div className="learn-item">How to create simple wireframes</div>

				<div className="learn-item">Working with Design system</div>

				<div className="learn-item">
					How to implement colours & images properly in your designs
				</div>

				<div className="learn-item">
					The dos & don't s around choosing fonts for web & mobile apps
				</div>

				<div className="learn-item">
					How to create your own icons, buttons & other UI components
				</div>

				<div className="learn-item">
					Terms such as Components, Constraints & Multi Dimensional Variants
				</div>

				<div className="learn-item">
					Free UI kits & plug-ins for Figma which will speed up our workflow
					dramatically!
				</div>

				<div className="learn-item">
					How to build a simple style guide, ready for client hand-off
				</div>

				<div className="learn-item">
					How to make both simple & advanced micro interactions, page
					transitions & animations
				</div>

				<div className="learn-item">
					Learn to design websites & mobile phone apps
				</div>

				<div className="learn-item">Work with fonts & colours</div>

				<div className="learn-item">Export production ready assets</div>

				<div className="learn-item">Create your first UX brief & persona</div>
			</div>
		</div>
	);
}

export function CourseIncludes() {
	return (
		<div className="includes-section">
			<h2>This course includes:</h2>
			<p style={{ fontSize: "1.4rem", marginBottom: "1.6rem" }}>
				This course includes our well designed ciricullum, resources and
				challenges curated to cater your needs so you can practice your skills
				as you learn.
			</p>
			<div className="includes-grid">
				<div className="includes-item">
					<span>📹</span> One to One teaching sessions
				</div>
				<div className="includes-item">
					<span>💻</span> Designing exercises
				</div>
				<div className="includes-item">
					<span>📄</span> Assignments
				</div>
				<div className="includes-item">
					<span>💾</span> Downloadable resources
				</div>
				<div className="includes-item">
					<span>🏆</span> Certificate of completion
				</div>
			</div>
		</div>
	);
}

export const courseSubtitle =
	"Master Mobile and Web Design, User Interface + User Experience (UI/UX Design)";

export const courseHeading = "Complete Figma UX/UI Masterclass";
